import React from 'react';
import { Card, CardContent } from './ui/card';
import { Shield, Code, Brain, Target } from 'lucide-react';

const About = ({ data }) => {
  const icons = [Shield, Code, Brain, Target];

  return (
    <section id="about" className="py-20 bg-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            {data.title}
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-emerald-400 to-blue-500 mx-auto"></div>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Column - Photo */}
          <div className="flex justify-center lg:justify-start">
            <div className="relative">
              <div className="w-80 h-80 rounded-2xl overflow-hidden shadow-2xl bg-slate-700/30 border border-slate-600">
                {/* Placeholder for professional photo */}
                <div className="w-full h-full bg-gradient-to-br from-emerald-300/10 to-blue-500/10 flex items-center justify-center">
                  <div className="text-center">
                    <div className="w-32 h-32 bg-gradient-to-br from-emerald-400 to-blue-500 rounded-full mx-auto mb-4 flex items-center justify-center">
                      <span className="text-4xl font-bold text-white">GS</span>
                    </div>
                    <p className="text-slate-400 text-sm">Professional Photo</p>
                  </div>
                </div>
              </div>
              {/* Decorative elements */}
              <div className="absolute -top-4 -right-4 w-24 h-24 bg-gradient-to-r from-emerald-400/20 to-blue-500/20 rounded-2xl -z-10"></div>
              <div className="absolute -bottom-4 -left-4 w-32 h-32 bg-gradient-to-r from-purple-400/20 to-emerald-500/20 rounded-2xl -z-10"></div>
            </div>
          </div>

          {/* Right Column - Description & Highlights */}
          <div className="space-y-8">
            <p className="text-lg text-slate-300 leading-relaxed">
              {data.description}
            </p>

            <div className="space-y-4">
              {data.highlights.map((highlight, index) => {
                const Icon = icons[index];
                return (
                  <div key={index} className="flex items-start space-x-4 group">
                    <div className="flex-shrink-0 p-2 bg-gradient-to-r from-emerald-500/20 to-blue-500/20 rounded-lg group-hover:from-emerald-500/30 group-hover:to-blue-500/30 transition-all duration-200">
                      <Icon className="h-6 w-6 text-emerald-400" />
                    </div>
                    <p className="text-slate-300 group-hover:text-white transition-colors duration-200">
                      {highlight}
                    </p>
                  </div>
                );
              })}
            </div>

            {/* Stats moved here */}
            <div className="grid grid-cols-2 gap-4 mt-8">
              {data.stats.map((stat, index) => (
                <Card key={index} className="bg-slate-700/50 border-slate-600 hover:bg-slate-700/70 transition-all duration-200 hover:scale-105 group">
                  <CardContent className="p-4 text-center">
                    <div className="text-2xl md:text-3xl font-bold bg-gradient-to-r from-emerald-400 to-blue-500 bg-clip-text text-transparent mb-1 group-hover:scale-110 transition-transform duration-200">
                      {stat.value}
                    </div>
                    <div className="text-slate-400 font-medium text-sm">
                      {stat.label}
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;